export enum ConvoCardDescription {
    ConvoDescription = 'convo',
    ChannelName = 'channel',
    Empty = 'empty',
}
